import AUTH_API from '@services/auth.service';
import {
  IAssignTrialSubjectReq,
  IAssignTrialSubjectRes,
  IGetAvailableTrialSubjectRes,
} from '@models/interfaces/subscription.interface';
import convertToFormData from '@utils/helpers/convertToFormData';

export async function getAvailableTrialSubject() {
  return await AUTH_API.post<IGetAvailableTrialSubjectRes>(
    'subscription/get_available_trial_subject/json',
  );
}

export async function assignTrialSubject(formData: IAssignTrialSubjectReq) {
  return await AUTH_API.post<IAssignTrialSubjectRes>(
    'subscription/assign_trial_subject/json',
    convertToFormData(formData),
  );
}
